import React from 'react'

const Imagen = (props) => {
    return (
        <>
            <div className="col m-3">
                <img className="img-fluid" src={props.path} alt=""/>                
            </div>
        </>
        )
}
export default Imagen